import { onAuthStateChanged, signInAnonymously, signOut } from 'firebase/auth'
import { doc, Timestamp, collection, addDoc, updateDoc, getDocs, getDoc, query, orderBy, setDoc, onSnapshot } from 'firebase/firestore'

export default class FirebaseConnect {
  static async addLastMessage(eventId, eventContactId, payload) {
    try {
      await setDoc(doc(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`), {
        last_message_content: payload['content'],
        last_message_from: payload['from'],
        last_message_status: 'unread',
        author_id: payload['author_id']
      })
      return true
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error adding message: ${e}`)
      return false
    }
  }

  static db() {
    return useNuxtApp().$firebaseDb
  }

  static authFirebase() {
    return useNuxtApp().$firebaseAuth
  }

  static signInFirebase(app) {
    if (!app.$store.user_firebase_id) {
      signInAnonymously(useNuxtApp().$firebaseAuth)
      onAuthStateChanged(useNuxtApp().$firebaseAuth, user => {
        if (user) app.$store.SET_STATE({ key: 'user_firebase_id', value: user.uid })
      })
    }
  }

  static async addEventContactMessages(eventId, eventContactId, message) {
    try {
      const docRefNoID = collection(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`, 'messages')
      return await addDoc(docRefNoID, {
        from: message['from'],
        content: message['content'],
        created_at: Timestamp.fromDate(new Date()),
        type: message['type'],
        status: message['status'],
        author_id: message['author_id']
      })
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error adding event contact: ${e}`)
      return false
    }
  }

  static async getLastMessage(eventId, eventContactId) {
    try {
      const eventContactRef = doc(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`)
      const docSnap = await getDoc(eventContactRef)
      return docSnap.data()
    } catch (e) {
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error getting last message: ${e}`)
    }
  }

  static async readLastMessage(eventId, eventContactId, userId, userFirebaseUid) {
    try {
      const docRef = doc(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`)
      const docSnap = await getDoc(docRef)
      if (docSnap.exists() && docSnap.data()['last_message_from'] === 'promoter' && docSnap.data()['last_message_status'] === 'unread') {
        await updateDoc(docRef, {
          last_message_status: 'read',
          author_id: userFirebaseUid
        })
        const messagesRef = collection(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`, 'messages')
        const q = query(messagesRef, orderBy('created_at', 'asc'))
        const querySnapshot = await getDocs(q)
        const countUnread = []
        querySnapshot.docs.forEach(doc => {
          if (doc.data()['from'] === 'promoter' && doc.data()['status'] === 'unread') {
            countUnread.push(doc.ref)
            updateDoc(doc.ref, { status: 'read', author_id: userFirebaseUid })
          }
        })
        if (countUnread.length > 0) this.minusCountNotification(userId, 'user', countUnread.length, userFirebaseUid)
      }
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error reading document: ${e}`)
    }
  }

  static async listenNewMessage(eventId, eventContactId) {
    try {
      const q = collection(useNuxtApp().$firebaseDb, `event_${eventId}`, `event_contact_${eventContactId}`, 'messages')
      const message = []
      await onSnapshot(q.orderBy('created_at'), querySnapshot => {
        querySnapshot.forEach(doc => {
          message.push(doc.data())
        })
      })
      return message
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error listening message: ${e}`)
    }
  }

  static async addCountNotification(id, type, userFirebaseUid) {
    try {
      const path = type === 'user' ? `user_${id}` : `promoter_${id}`
      const colectionRef = collection(useNuxtApp().$firebaseDb, path)
      const docSnap = await getDocs(colectionRef)
      if (docSnap.empty) {
        await addDoc(colectionRef, {
          count: 1,
          author_id: userFirebaseUid
        })
      } else {
        docSnap.docs.forEach(doc => {
          const newValue = doc.data()['count'] + 1
          updateDoc(doc.ref, { count: newValue, author_id: userFirebaseUid })
        })
      }
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error checkNewMessage: ${e}`)
    }
  }

  static async minusCountNotification(id, type, count, userFirebaseUid) {
    try {
      const path = type === 'user' ? `user_${id}` : `promoter_${id}`
      const colectionRef = collection(useNuxtApp().$firebaseDb, path)
      const docSnap = await getDocs(colectionRef)
      if (docSnap.empty) {
        await addDoc(colectionRef, {
          count: 0,
          author_id: userFirebaseUid
        })
      } else {
        docSnap.docs.forEach(doc => {
          const newValue = doc.data()['count'] >= 1 ? doc.data()['count'] - count : 0
          updateDoc(doc.ref, { count: newValue, author_id: userFirebaseUid })
        })
      }
    } catch (e) {
      // TOODO CHECK THIS
      if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(`Error subtracting count: ${e}`)
    }
  }

  static async signOut() {
    signOut(useNuxtApp().$firebaseAuth)
      .then(() => {
        console.log('signOut Success')
      })
      .catch(error => {
        // TOODO CHECK THIS
        if (useNuxtApp().$bugsnag) useNuxtApp().$bugsnag.notify(error)
        return error.code
      })
  }
}
